
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/web/how-to-import-wallet-in-komodo-web-wallet",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/web/how-to-import-wallet-in-komodo-web-wallet/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/web/how-to-import-wallet-in-komodo-web-wallet"])
      });
    }
  